import { CommonModule } from '@angular/common';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { ModalModule, ModalDirective } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AppComponent } from '../../app.component';
import { TermsOfServiceMainComponent } from './terms-of-service-main.component';
import { WebApiService } from '../../service/web-api.service';
import { DisplayService } from '../../service/display.service';
import { CustomViewService } from '../../service/custom-view.service';
import { DocumentService } from '../../service/document.service';

import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { DocumentModalComponent } from '../document-modal/document-modal.component';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  providers: [WebApiService, CustomViewService, DocumentService]
})
export class TermsOfServiceComponent implements OnInit {

  constructor(private compiler: Compiler, private customViewService: CustomViewService,
    private appComponent: AppComponent, private displayService: DisplayService,
    private documentService: DocumentService, public router: Router, public translateService: TranslateService,
    private sanitizer: DomSanitizer) { }

  @ViewChild('confirmModal', { static: false }) confirmModal: ConfirmModalComponent;
  @ViewChild('documentModal', { static: false }) documentModal: DocumentModalComponent;

  // 画面ID
  readonly SCREEN_ID = 'O05';

  // タイトルロゴ
  public dispZ0001: string;
  // 銀行利用規約リンク
  public dispO0501: string;

  // ページ番号定義
  public pageNo: number;
  // 操作クラス定義
  public comp: TermsOfServiceMainComponent;

  // テンプレートファイ名（HTML）
  public templateHtml: string;
  // テンプレートファイル（CSS）
  public templateCss: string;
  // 画面資材ルートURL
  public assetsBaseUrl: string;
  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // 画面項目定義
  public consentDisabled: boolean;

  // 書面情報
  public documentInfoList: any[];

  // サービス名
  public serviceName: string;

  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  async ngOnInit() {
    this.pageNo = 1;
    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }
    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }
    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/terms-of-service/' + this.serviceName + '_terms-of-service';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_terms-of-service.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      this.dispO0501 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
        if (data.displayInfo.O0501 != null) {
          this.dispO0501 = data.displayInfo.O0501;
        }
      }

      // 書面情報
      this.documentService.execAuthGetUnreadDocument().subscribe(documentData => {
        this.documentInfoList = documentData.documentInfoList;
        if (this.documentInfoList == null) {
          this.documentInfoList = [];
        }

        // 規約埋め込み（iframe）時にunsafeなURLとしてエラーとなるのでURLを無害化しておく
        for (const doc of this.documentInfoList) {
          const sanitizedDocumentUrl = this.sanitizer.sanitize(SecurityContext.URL, doc.url);
          doc.url = this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedDocumentUrl);
        }

        // カスタムページ表示
        this.directInjection();
      });
    });

    this.consentDisabled = true;
  }

  /**
   * コンポーネントを生成し親コンポーネントに挿入する
   *
   */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/terms-of-service/' + this.serviceName + '_terms-of-service' + '/' + this.pageNo,
      'page_title': 'terms-of-service',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'terms-of-service',
      'page_location': this.serviceName + '/terms-of-service/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);

    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-terms-of-service-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class TermsOfServiceModuleComponent extends TermsOfServiceMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [TermsOfServiceModuleComponent],
      exports: [TermsOfServiceModuleComponent]
    })
    class TermsOfServiceModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(TermsOfServiceModule);
    // Angular モジュールから TermsOfServiceModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === TermsOfServiceModuleComponent;
    });

    // TermsOfServiceModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // // componentのインスタンスを取得する。
    this.comp = (<TermsOfServiceModuleComponent>componentRef.instance);
    this.comp.init(this, this.confirmModal, this.documentService, this.documentModal);
  }
}
